'use client'

import { useState } from 'react'

import { Alignment, Fit, Layout, useRive } from '@rive-app/react-canvas'

interface ChikuMascotProps {
    className?: string
    staticBaseUrl?: string
}

export function ChikuMascot({ className, staticBaseUrl }: ChikuMascotProps) {
    const [reducedMotion] = useState(
        () =>
            typeof window !== 'undefined' &&
            window.matchMedia('(prefers-reduced-motion: reduce)').matches,
    )

    const { RiveComponent } = useRive({
        src: `${staticBaseUrl}nexus/_next/static/chikuwavestates.riv`,
        stateMachines: 'State Machine 1',
        autoplay: !reducedMotion,
        // autoBind wires the ChikuController view model that the Luau script
        // reads for arm/eye state and the auto-wave. Without it the runtime
        // can't find the controller and the animation stays frozen.
        autoBind: true,
        layout: new Layout({ fit: Fit.Cover, alignment: Alignment.BottomCenter }),
    })

    return (
        <RiveComponent
            className={className}
            role="img"
            aria-label="Chiku, Wanderu's travel mascot"
        />
    )
}
